import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  resetReflectionsApiService,
  type ResetReflectionsRequest,
} from "@/generated/fastapi";

export async function resetReflections(
  accessToken: string | null | undefined,
  request: ResetReflectionsRequest,
) {
  if (!request.thoughts_id || request.thoughts_id.length === 0) {
    return null;
  }

  const response = await resetReflectionsApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200) {
    throw new Error(`Failed to reset reflections (${response.status})`);
  }

  return response.data ?? null;
}
